import { createFileRoute } from '@tanstack/react-router';
import { CompaniesList } from '@/components/companies/companies-list';
import { useProjects } from '@/hooks/use-projects';

export const Route = createFileRoute('/_auth/_side-layout/companies')({
  component: CompaniesPage,
});

// Keyed by project so a sidebar project switch never shows the last project's rows.
function CompaniesPage() {
  const { projectId } = useProjects();
  return <CompaniesList key={projectId ?? 'none'} />;
}
